import IconSmallGrab from '~/components/icon/IconSmallGrab.vue';
import IconLargeGrab from '~/components/icon/IconLargeGrab.vue';

export default {
    computed: {
        bagSizes() {
            if (!this.services.sizes) {
                return [];
            }
            return [
                {
                    name: this.services.sizes.sm?.split(' ')[0],
                    slug: 'sm',
                    text: this.services.size_descriptions.sm?.replace(/ /g, '<br>'),
                    icon: IconSmallGrab,
                },
                {
                    name: this.services.sizes.md?.split(' ')[0],
                    slug: 'md',
                    text: this.services.size_descriptions.md?.replace(/ /g, '<br>'),
                    icon: IconLargeGrab,
                },
                {
                    name: this.services.sizes.lg?.split(' ')[0],
                    slug: 'lg',
                    text: this.services.size_descriptions.lg?.replace(/ /g, '<br>'),
                    icon: IconLargeGrab,
                },
            ];
        },
    },
};
